import React from 'react';

interface UseFontLoadedListenerConfig {
  onFontLoadingDone: (evt: FontFaceSetLoadEvent) => void;
}

interface UseFontLoadedListenerResult {
  isFontsLoaded: boolean;
}

const useFontLoadedListener = (
  config?: UseFontLoadedListenerConfig,
): UseFontLoadedListenerResult => {
  const { onFontLoadingDone } = config || {};

  React.useEffect(() => {
    document.fonts.addEventListener('loadingdone', onFontLoadingDone);

    return () => {
      document.fonts.removeEventListener('loadingdone', onFontLoadingDone);
    };
  }, [onFontLoadingDone]);

  return {
    isFontsLoaded: document.fonts.status === 'loaded',
  };
};

export default useFontLoadedListener;
